/**
 * WeChat Browser Detection Utilities
 * Detects if user is in WeChat browser, mobile device, or desktop
 */

/**
 * Check if running in WeChat browser
 * WeChat browser User-Agent contains "MicroMessenger"
 */
export const isWeChat = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger');
};

/**
 * Check if running on iOS device (iPhone, iPad, iPod)
 */
export const isIOS = () => {
  if (typeof window === 'undefined') return false;
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
};

/**
 * Check if running on mobile device
 */
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
};

/**
 * Check if running inside WeChat Mini Program
 * Mini Program user agent contains "miniProgram"
 */
export const isWeChatMiniProgram = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.includes('miniprogram');
};

/**
 * Get current environment for conditional rendering
 * @returns {'wechat-desktop'|'wechat-mobile'|'mobile-non-wechat'|'desktop'}
 */
export const getEnvironment = () => {
  const inWeChat = isWeChat();
  const onMobile = isMobile();

  if (inWeChat && onMobile) {
    return 'wechat-mobile';
  } else if (inWeChat && !onMobile) {
    return 'wechat-desktop';
  } else if (!inWeChat && onMobile) {
    return 'mobile-non-wechat';
  } else {
    return 'desktop';
  }
};

/**
 * Copy text to clipboard with fallback for older browsers
 */
export const copyToClipboard = async (text) => {
  try {
    // Modern clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers or non-HTTPS
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        textArea.remove();
        return successful;
      } catch (err) {
        textArea.remove();
        return false;
      }
    }
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};

/**
 * Get user agent for debugging
 */
export const getUserAgent = () => {
  if (typeof window === 'undefined') return 'server';
  return window.navigator.userAgent;
};
